<script>
/* eslint-disable no-console */
import NewForm from './New'
export default {
  mixins: [NewForm],
  data() {
    return {
      valid: null,
      id: null,
      root: {},
    }
  },
  methods: {
    load() {
      this.$http
        .get(`/archive-configs/${this.$route.query.id}`)
        .then((res) => {
          this.root = res.data
        })
    },
    save() {
      this.$http
        .put(`/archive-configs/${this.$route.query.id}`, this.root)
        .then(() => {
          this.returnToList()
          this.$message('', 'Success')
        })
        .catch(() => {
          this.$message('', 'Error')
        })
    },
    returnToList() {
      this.$router.push({
        name: 'M2500',
      })
    },
  },
  mounted() {
    this.load()
  },
}
</script>
